export default {
  namespaced: true,
  state: {
    active: false,
  },
  getters: {
    active: state => state.active,
  },
  mutations: {
    setMenuMutate(state, data) {
      state.active = data;
    },
  },
  actions: {
    setMenu(context, data) {
      context.commit('setMenuMutate', data);
    },
  },
};
